import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/clasificacionTercero/importer/clasificacionTerceroImporterActions';

export default importerReducers(actions);
